import { TreeSelect, TreeSelectProps } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Org } from "@/types/org";

interface SOrgSelectProps extends TreeSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  loading?: boolean;
  list?: Array<Org>;
}

const SOrgSelect: FC<SOrgSelectProps> = ({
  value, onChange, loading, list = [], ...props
}) => {
  const { t } = useTranslation();

  return (
    <TreeSelect
      showSearch
      style={{ width: '100%' }}
      value={value}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      placeholder={t('layout.selectOrg')}
      // allowClear
      loading={loading}
      treeDefaultExpandAll
      onChange={onChange}
      treeData={list}
      fieldNames={{
        value: 'id',
        label: 'name',
        children: 'subs'
      }}
      treeNodeFilterProp="name"
      {...props}
    />
  );
};

export default SOrgSelect;
